module.exports = __webpack_public_path__ + "static/media/SDG11.b318d994.mp4";